module.exports = __webpack_public_path__ + "static/img/ic_price_list.8dfa1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_price_list.png
// module id = EvUZ
// module chunks = 21